/* eslint-disable no-useless-escape */
const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default email =>
  !email || emailPattern.test(String(email).toLowerCase());



// WEBPACK FOOTER //
// ./src/utils/validations/emailValidator.js